<template>
  <div class="difficulty-selector">
    <div class="show-all-button btn btn-secondary btn-filter" :class="{'selected': showAll}" @click="toggleShowAll()">
      Alle
    </div>
    <div v-for="difficulty in difficulties" class="difficulty-button btn btn-secondary btn-filter"
         :class="{'selected': difficulty.selected}" @click="selectDifficulty(difficulty)">
      <img :src="'https://res.cloudinary.com/dspi5zyaa/image/upload/v1638971079/eh-platform/icons/difficulties/'
                 + difficulty.icon + '.svg'">
    </div>
  </div>
</template>

<script>
import {eventBus} from "../../main";

export default {
  name: "DifficultyFilter",
  props: {

  },
  data() {
    return {
      showAll: false,
      difficulties: [
        {
          complexity: '1',
          name: 'leicht',
          icon: 'difficulty-icon-easy-new',
          selected: false
        },
        {
          complexity: '2',
          name: 'mittel',
          icon: 'difficulty-icon-intermediate-new',
          selected: false
        },
        {
          complexity: '3',
          name: 'schwer',
          icon: 'difficulty-icon-hard-new',
          selected: false
        },
        {
          complexity: '4',
          name: 'hardcore',
          icon: 'difficulty-icon-extra-hard-new',
          selected: false
        },
      ]
    }
  },
  mounted() {
      if (typeof this.$route.query !== "undefined" && this.$route.query.hasOwnProperty("difficultyFilter")) {
      let filter = this.$route.query.difficultyFilter;
      let filterList = filter.split(",");
      for (let filterDifficulty of filterList) {
        for (let givenDifficulty of this.difficulties) {
          if (givenDifficulty.complexity === filterDifficulty) {
            givenDifficulty.selected = true;
          }
        }
      }
      this.$emit('selectDifficulties', this.difficulties);
    }
  },
  methods: {
    resetFilters: function () {
      for (let difficulty of this.difficulties) {
        difficulty.selected = false;
      }
      this.showAll = true;
      this.$emit('showAll', this.showAll);
    },
    toggleShowAll() {
      if (!this.showAll) {
        for (let difficulty of this.difficulties) {
          difficulty.selected = false;
        }
      }
      this.showAll = !this.showAll;
      this.$emit('selectDifficulties', []);
      this.$emit('showAll', this.showAll);
    },
    selectDifficulty(difficulty) {
      difficulty.selected = !difficulty.selected;
      this.showAll = this.difficulties.filter((diff) => diff.selected).length === 0;
      this.$emit('selectDifficulties', this.difficulties);
      eventBus.$emit('selectDifficulties', this.difficulties);
    },
  },
}
</script>

<style scoped>
  .difficulty-selector {
    display:inline-block;
    justify-content: flex-start;
    margin: 1rem 0 1rem 0;
    position: relative;
    font-size: 13px;
    font-weight: 400;
    padding: 0 1rem 0.8rem 1rem;
  }

  .difficulty-button, .show-all-button {
    display: inline-block;
    margin: 0 .5rem 0 0;
  }

  .difficulty-button img {
    width: 35px;
  }

  .btn-filter {
    width: 6rem;
    height: 3.2rem;
    background-color: transparent;
  }

  .btn-filter:hover, .btn-filter:active, .selected {
    background-color: var(--button-background);
  }

  @media (max-width: 1528px) {
        .difficulty-selector {
            display: block;
        }
        .show-all-button {
            margin-right: 0;
        }
  }

  @media (max-width: 400px) {
    .btn-filter {
      width: 5rem;
      padding-left: 5px;
      padding-right: 5px;
    }
  }
</style>